// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as OrderStatus from "../../../../../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as Date$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as OrderStatusParser from "../../../vm-mapper/driver-records/OrderStatusParser.bs.js";

function getOrderStatusStyleClass(order) {
  var match = OrderStatusParser.OrderStatusSubStatusMapper.getStatusfromSubStatus(order.orderStatus);
  switch (match) {
    case /* Live */0 :
        return "u-color-dark-blue";
    case /* Completed */1 :
        return "u-color-success";
    case /* Cancelled */2 :
        return "u-color-red";
    case /* Open */3 :
        return "u-color-dark-grey";
    
  }
}

function getColumnSchema(workspaceDispatch) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Order Id"
            },
            accessor: (function (order) {
                return {
                        TAG: /* ActionButton */3,
                        _0: order.orderId,
                        _1: (function (param) {
                            return Curry._2(workspaceDispatch.addTab, {
                                        TAG: /* OrderDetails */10,
                                        _0: order.orderId,
                                        _1: undefined
                                      }, false);
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Order Pickup Time"
              },
              accessor: (function (order) {
                  return {
                          TAG: /* Text */0,
                          _0: Date$Catalyst.toString("Do MMM YY HH:mm", order.orderPickupTime)
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Status"
                },
                accessor: (function (order) {
                    return {
                            TAG: /* Custom */5,
                            _0: (function (param) {
                                return React.createElement("div", {
                                            className: getOrderStatusStyleClass(order)
                                          }, OrderStatus.toString(order.orderStatus));
                              })
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

export {
  getOrderStatusStyleClass ,
  getColumnSchema ,
  
}
/* react Not a pure module */
